import React, { useState } from "react";
import { todayMarketHoldTime } from "../utils/constants";
import { OverlayTrigger, Popover } from "react-bootstrap";
import moment from "moment";
import { useSelector } from "react-redux";
import { useEffect } from "react";



const StockStrength = ({id, selectedDate, symbol, todayLTP, details}) =>{
    // console.log("todayLTP", id, symbol, todayLTP, details,);
    
    const deliveryDataList = useSelector((state) => state.deliveryData.value);
    
    const [deliveryData, setDeliveryData] = useState([]);
    const [prevDeliveryData, setprevDeliveryData] = useState([]);
    
    

    useEffect(() => {
        let list = [];

        // ✅ Case 1: already array
        if (Array.isArray(deliveryDataList)) {
            list = deliveryDataList;
        }
        // ✅ Case 2: object → convert to array
        else if (deliveryDataList && typeof deliveryDataList === 'object') {
            list = Object.values(deliveryDataList);
        }

        

        if (list.length > 0) {
            const item = list.find((item) => item.symbol === symbol);

            if (item) {
                setDeliveryData(item);
                setprevDeliveryData(item?.stock_data?.[1] || null);
            }
        }

    }, [symbol, deliveryDataList]);


        const togglePopover = (id) => {
        setTimeout(() =>{
                document.querySelectorAll(".strengthTooltip").forEach(el => {
                    if (el != null) {
                        // el.remove();
                    }
                    // console.log(el)
                });

            }, 100)
        };


       
        
        
        let rank = 0;
        let MarketCap = parseInt((moment(selectedDate).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? todayLTP?.MARKETCAP: deliveryData?.MARKETCAP*10000000);

        let Volume = parseInt((moment(selectedDate).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? todayLTP?.VOLUME: deliveryData?.stock_data?.[0]?.ttl_trd_qty);
        let Prev_Volume = parseInt((moment(selectedDate).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? deliveryData?.stock_data?.[0]?.ttl_trd_qty:deliveryData?.stock_data?.[1]?.ttl_trd_qty);
        
        let LTP = parseFloat((moment(selectedDate).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? todayLTP?.LTP: deliveryData?.stock_data?.[0]?.close_price);
        let Turnover = Volume * LTP;
        let Turnover_per =  parseFloat(((Turnover/MarketCap) * 100).toFixed(2));
        let Turnover_Cap = Math.round(Turnover/10000000);

        let RSI = parseFloat(deliveryData?.RSI || 0);
        let ADX = parseFloat(deliveryData?.ADX || 0);
        let ATR_PER = parseFloat(deliveryData?.ATR_PER || 0);
        let SMA20 = parseFloat(deliveryData?.SMA20  || 0);
        let SMA50 = parseFloat(deliveryData?.SMA50  || 0);
        let SMA200 = parseFloat(deliveryData?.SMA200  || 0);
        let angle_5 = parseFloat(deliveryData?.angle5  || 0);
        let angle_10 = parseFloat(deliveryData?.angle10  || 0);
        let angle_15 = parseFloat(deliveryData?.angle15  || 0);
        let angle_20 = parseFloat(deliveryData?.angle20  || 0);
        let AverageVol = parseInt(deliveryData?.avgVolume  || 0);
        let trueAvgVolume = Number(deliveryData?.trueAvgVolume) === 1;
        let TodayIncVol = parseFloat(((Volume - Prev_Volume) * 100) / Prev_Volume).toFixed(2);
        let Delivery_per = parseFloat(deliveryData?.stock_data?.[0]?.delivery_per || 0);
        let Prev_delivery_per = parseFloat(prevDeliveryData?.delivery_per  || 0);
        let IncreaseDel = (Delivery_per - Prev_delivery_per).toFixed(2);
        let Down_52 = ((details?.high52w - todayLTP?.LTP)*100/details?.high52w).toFixed(2);
        let spikes = Number(deliveryData?.SMEntery) === 1;
        let volume_spike = Number(deliveryData?.volume_spike) === 1;
        let structureData = deliveryData?.structure_json;
        let structure = structureData?.structure || '';
        let EMA_Angle = parseFloat(deliveryData?.EMA_Angle);
        let delivery_date = deliveryData?.delivery_date
        


        // Rank 1 : Structure
        if (["UPTREND", "BULLISH_CHOCH", "EARLY_UPTREND"].includes(structure)) {
            rank += 1;
        }

        // Rank 2 : Momentum
        if(EMA_Angle > 25){
            rank += 1;
        }

        // Rank 3 : RSI
        if(RSI > 35 && RSI < 85){
            rank += 1;
        }

        // Rank 4 : ADx
        if(ADX > 30 && ADX < 85){
            rank += 1;
        }

        // Rank 5 : If ATR_PER > ADTR, volatility is increasing → Expect big price movements
        if(ATR_PER > 5){
            rank += 1;
        }  

        // Rank 6 : LTP > SMA20
        if(todayLTP?.LTP > SMA20){
            rank += 1;
        }  

        // Rank 7 : SMA20 > SMA50
        if(SMA20 > SMA50){
            rank += 1;
        }  

        // Rank 8 : SMA50 > SMA200
        if(SMA50 > SMA200){
            rank += 1;
        }    

        // Rank 9 : volume_spike
        if(spikes === true){
            rank += 1;
        } 

        if(volume_spike === true){
            rank += 1;
        } 

        // Rank 10 : Angle 5
        if(angle_5 > 25){
            rank += 1;
        } 

        // Rank 11 : Angle 10
        if(angle_10 > 20){
            rank += 1;
        } 
        
        // Rank 12 : Angle 15
        if(angle_15 > 15){
            rank += 1;
        }  
        
        // Rank 13 : Angle 20
        // if(angle_20 > 10){
        //     rank += 1;
        // }    

        // Rank 13 : Volume
        if(Volume > 200000 && trueAvgVolume === true){
            rank += 1;
        }   

        // Rank 14 : AverageVol
        if(Volume > AverageVol){
            rank += 1;
        } 

        // Rank 15 : TodayIncVol
        if(TodayIncVol > 25){
            rank += 1;
        } 

        // Rank 16 : Delivery_per %
        if(Delivery_per >= 50){
            rank += 1;
        }   

        // Rank 17 : IncreaseDel
        if(IncreaseDel > 10){
            rank += 1;
        } 

        // Rank 18 : Down_52
        if(Down_52 >= 8 && Down_52 <= 30){
            rank += 1;
        } 
        
        // Rank 19 : MarketCap
        if(MarketCap >= 1000){
            rank += 1;
        } 

        // Rank 20 : Turnover
        if(Turnover_per >= 5){
            rank += 1;
        }   


        const strength = {
            // 'strength'          : rank,
            'structure'         : structure,
            'EMA_Angle'         : EMA_Angle,
            'RSI'               : RSI,
            'ADX'               : ADX,
            'ATR_PER'           : ATR_PER,
            'SMA20'             : SMA20,
            'SMA50'             : SMA50,
            'SMA200'            : SMA200,
            'angle_5'           : angle_5,
            'angle_10'          : angle_10,
            'angle_15'          : angle_15,
            'spikes'            : spikes,
            'volume_spike'      : volume_spike,
            'Volume'            : Volume,
            'AverageVol'        : AverageVol,
            'trueAvgVolume'     : trueAvgVolume,
            'TodayIncVol'       : TodayIncVol,
            'Delivery_per'      : Delivery_per,
            'IncreaseDel'       : IncreaseDel,
            'Down_52'           : Down_52,
            'MarketCap'         : Math.round(MarketCap/10000000),
            'Turnover_per'      : Turnover_per
        };


        
        const green = "#e9ffec";
        const red = "#ffdcdc";

        const popover = (
                <Popover id={`popover-${id}`} className="strengthTooltip">
                    <Popover.Header as="h4">{symbol} [{rank}/{Object.keys(strength).length}] | {moment(delivery_date).format("DD/MM/YYYY")}</Popover.Header>
                    <Popover.Body>
                            <ul>
                                <li key={1} style={{background:(strength.structure === "BULLISH_CHOCH" || strength.structure === "BULLISH" || strength.structure === "UPTREND")? green:red }}><span>Structure</span>        {strength.structure}</li>
                                <li key={2} style={{background:(strength.EMA_Angle > 50)? green:red }}><span>Momentum</span>        {strength.EMA_Angle}</li>
                                <li key={3} style={{background:(strength.RSI > 35 && strength.RSI < 80)? green:red }}><span>RSI</span>        {strength.RSI}</li>
                                <li key={4} style={{background:(strength.ADX > 30 && strength.ADX < 80)? green:red }}><span>ADX</span>        {strength.ADX}</li>
                                <li key={5} style={{background: strength.ATR_PER > 5 ? green:red }}><span>ATR_PER</span>        {strength.ATR_PER}</li>
                                <li key={6} style={{background:(LTP > strength.SMA20)? green:red }}><span>SMA20</span>        {strength.SMA20}</li>
                                <li key={7} style={{background:(strength.SMA20 > strength.SMA50)? green:red }}><span>SMA50</span>        {strength.SMA50}</li>
                                <li key={8} style={{background:(strength.SMA50 > strength.SMA200)? green:red }}><span>SMA200</span>        {strength.SMA200}</li>
                                <li key={9} style={{background:(strength.angle_5 > 25)? green:red }}><span>Deg 5days</span>        {strength.angle_5}°</li>
                                <li key={10} style={{background:(strength.angle_10 > 20)? green:red }}><span>Deg 10days</span>        {strength.angle_10}°</li>
                                <li key={11} style={{background:(strength.angle_15 > 15)? green:red }}><span>Deg 15days</span>        {strength.angle_15}°</li>
                                
                                {/* <li key={12} style={{background:(strength.angle_5 > strength.angle_9 && strength.angle_9 > strength.angle_14)? green:red }}><span>Deg 5° &gt; 9° &gt; 14°</span>      {strength.angle_5}° | {strength.angle_9}° |  {strength.angle_14}°</li> */}

                                <li key={13} style={{background:(strength.spikes === true)? green:red }}><span>Spikes</span>        {strength.spikes === true? 'Yes':'No'}</li>
                                <li key={14} style={{background:(strength.volume_spike === true)? green:red }}><span>Volume Spike</span>        {strength.volume_spike === true? 'Yes':'No'}</li>
                                <li key={15} style={{background:(strength.trueAvgVolume === true)? green:red }}><span>Volume</span> {strength.Volume.toLocaleString('en-IN')}</li>
                                <li key={16} style={{background:(strength.Volume >= strength.AverageVol  && strength.trueAvgVolume === true)? green:red }}><span>Average Vol</span>        {strength.AverageVol.toLocaleString('en-IN')}</li>
                                <li key={17} style={{background:(strength.TodayIncVol >= 25)? green:red }}><span>Today Inc Vol Per</span>        {strength.TodayIncVol}%</li>
                                
                                <li key={18} style={{background:(strength.Delivery_per >= 50)? green:red }}><span>Delivery Per</span>        {strength.Delivery_per}%</li>
                                <li key={19} style={{background:(strength.IncreaseDel >= 5)? green:red }}><span>Increase Del</span>        {strength.IncreaseDel}%</li>
                                <li key={20} style={{background:(strength.Down_52 >= 8 && strength.Down_52 <= 30)? green:red }}><span>Down_52</span>        {strength.Down_52}%</li>
                                <li key={21} style={{background:(strength.MarketCap >= 1000)? green:red }}><span>MarketCap</span>        {parseInt(strength.MarketCap).toLocaleString('en-IN')}</li>
                                <li key={22} style={{background:(strength.Turnover_per > 5)? green:red }}><span>Turnover</span>       {Turnover_Cap.toLocaleString('en-IN')} [{strength.Turnover_per}%]</li>
                            </ul>
                    </Popover.Body>
                </Popover>
                );

        //   console.log("strength", strength, Object.keys(strength).length)
    
    return(
        <React.Fragment>
                <td className="strength_count" style={{background: 
                    rank >=17? "#649664": 
                    rank >=14? "#9ce49c": 
                    rank >=12? "#d1efd1": 
                    rank >=9? "#f6fa83": 
                    // rank >=8? "#ff8d8d": 
                    "#ff8d8d",
                    "cursor":"pointer"
                    }}>

                    <OverlayTrigger
                        key = {id}
                        placement = "right"
                        trigger = "click"
                        rootClose
                        overlay={popover}
                    >
                    <div 
                        onClick={(e) => {
                            e.preventDefault();
                            togglePopover(id);
                        }}
                    >{rank}/{Object.keys(strength).length}</div>
                    </OverlayTrigger>
                </td>
    </React.Fragment>
    )

}
export default StockStrength;